import axios from "axios";
import { getCredObjFromLocalStorage } from "./localStorage";

const url = () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
        return "http://localhost:8000/api/v1";
    } else if (process.env.REACT_APP_NODE_ENV === "beta") {
        return "https://www.betareadrivalsapi.com/api/v1"
    } else if (process.env.REACT_APP_NODE_ENV === "production") {
        return "https://www.readrivalsapi.com/api/v1"; 
    } else {
        return "http://localhost:8000/api/v1";
    }
};

const fetchAPI = axios.create({
    baseURL:url(),
});
fetchAPI.interceptors.request.use(
  (config) => {
    const credObj = getCredObjFromLocalStorage();
    if (credObj?.token) {
      config.headers.Authorization = `Bearer ${credObj.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export const gutendexAPI = axios.create({
  baseURL: "https://gutendex.com",
});
export default fetchAPI;